import { render, staticRenderFns } from "./Baikal.vue?vue&type=template&id=7b540ee4"
import script from "./Baikal.vue?vue&type=script&lang=js"
export * from "./Baikal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports